import { useQueryClient } from '@tanstack/react-query';

import type {
  FetchLocationsQueryParams,
  Location,
} from '@/api/v4/locations.api';
import { fetchLocations } from '@/api/v4/locations.api';
import { QueryKey } from '@/config/query-client';

export const useFetchLocationsCached = () => {
  const queryClient = useQueryClient();

  return async (params: FetchLocationsQueryParams): Promise<Location[]> => {
    return queryClient.fetchQuery({
      queryKey: [QueryKey.Locations, params],
      queryFn: () => fetchLocations(params),
    });
  };
};
